import { apiSlice } from "./apiSlice";
import {
  ListTrainingsParams,
  ListTrainingsResult,
  TrainingRow,
} from "../../services/formacion/formacion.types";

export interface TrainingsPage {
  data: TrainingRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
}

export const formacionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTrainingsPaginated: builder.query<TrainingsPage, ListTrainingsParams>({
      query: ({
        schoolId,
        page,
        pageSize,
        search,
        audience,
        status,
        sortBy,
        sortDir,
      }) => ({
        url: "/trainings",
        method: "GET",
        params: {
          ...(schoolId !== null && { schoolId }),
          page,
          pageSize,
          ...(search && { search }),
          ...(audience && { audience }),
          ...(status && { status }),
          ...(sortBy && { sortBy }),
          ...(sortDir && { sortDir }),
        },
      }),
      transformResponse: (response: ListTrainingsResult): TrainingsPage => ({
        data: response.data,
        pagination: {
          page: response.page,
          pageSize: response.pageSize,
          total: response.total,
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "Training" as const,
                id,
              })),
              { type: "Training" as const, id: "LIST" },
            ]
          : [{ type: "Training" as const, id: "LIST" }],
    }),
    deleteTraining: builder.mutation<
      void,
      { id: number; schoolId: number | null }
    >({
      query: ({ id, schoolId }) => ({
        url: `/trainings/${id}`,
        method: "DELETE",
        params: { ...(schoolId !== null && { schoolId }) },
      }),
      invalidatesTags: [{ type: "Training", id: "LIST" }],
    }),
  }),
});

export const { useGetTrainingsPaginatedQuery, useDeleteTrainingMutation } =
  formacionApi;
